module.exports = __webpack_public_path__ + "img/ry3.f74a12f7.png";